import React, { useState } from "react";
import { Typography } from "@mui/material";
import ModalShell from "./ModalShell";
import FileDropzone from "./FileDropzone";
import { CollectionVariant } from "../../../api/derin";
import { subtitleSx } from "./tokens";

interface UploadVersionModalProps {
  open: boolean;
  variant: CollectionVariant | null;
  onClose: () => void;
  onSubmit: (file: File) => void;
  isSubmitting?: boolean;
}

const UploadVersionModal: React.FC<UploadVersionModalProps> = ({
  open,
  variant,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const [file, setFile] = useState<File | null>(null);

  const close = () => {
    setFile(null);
    onClose();
  };

  const nextVersion = variant?.version ? Number(variant.version) + 1 : 1;

  return (
    <ModalShell
      open={open}
      onClose={close}
      title="Upload new version"
      subtitle={
        variant
          ? `Creating version ${nextVersion} of "${variant.label}". Only this variant is affected — the other variants keep their current versions, and previous versions stay visible to you.`
          : undefined
      }
      confirmLabel="Upload new version"
      onConfirm={() => {
        if (file) {
          onSubmit(file);
        }
      }}
      confirmDisabled={!file}
      isSubmitting={isSubmitting}
    >
      <FileDropzone file={file} onSelect={setFile} placeholder="Click to upload or drag and drop" />
      {variant && <Typography sx={subtitleSx}>Variant ID: {variant.surveyOriginalId}</Typography>}
    </ModalShell>
  );
};

export default UploadVersionModal;
